// PodiUmScript brand assets (real transparent background, served locally)
// Processed from the original uploads to remove the near-white background.
// Centralized so swaps are a one-liner.

// Colored variants (navy + orange on transparent)
export const BRAND_MONOGRAM = "/brand/podiumscript-monogram.png";

export const BRAND_WORDMARK_HORIZONTAL = "/brand/podiumscript-horizontal.png";

// Vazada / cut-out (solid black on transparent) — pair with `invert`
// filter to render as white on dark backgrounds.
export const BRAND_WORDMARK_VAZADA = "/brand/podiumscript-vazada.png";

// Default logo used when a program has no custom logo
export const DEFAULT_PROGRAM_LOGO = BRAND_MONOGRAM;
